import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Typography } from '@mui/material';

import Tabs from '../../components/Tabs';
import Tab from '../../components/Tabs/Tab';
import { i18nNS } from '../../i18n';
import routes from '../../pages/routes';
import { AppBar } from './styles';
import { ClassTabItems } from './types';
import useClassHeaderVM, { ClassTabIds, ClassTabPanelIds } from './vm';

const ClassHeader = () => {
  const { t } = useTranslation([i18nNS.CLASS, i18nNS.GLOSSARY]);
  const { activeTab, params } = useClassHeaderVM();

  return (
    <AppBar>
      <Tabs value={activeTab} centered aria-label={t('class_page_tabs', { ns: i18nNS.CLASS })}>
        <Tab
          id={ClassTabIds[ClassTabItems.ACTIVITIES]}
          aria-controls={ClassTabPanelIds[ClassTabItems.ACTIVITIES]}
          component={Link}
          to={routes.classActivities.url(params)}
          value={ClassTabItems.ACTIVITIES}
          label={<Typography component="span">{t('activities', { ns: i18nNS.GLOSSARY })}</Typography>}
        />
        <Tab
          id={ClassTabIds[ClassTabItems.AGENDA]}
          aria-controls={ClassTabPanelIds[ClassTabItems.AGENDA]}
          component={Link}
          to={routes.classAgenda.url(params)}
          value={ClassTabItems.AGENDA}
          label={<Typography component="span">{t('agenda', { ns: i18nNS.GLOSSARY })}</Typography>}
        />
        <Tab
          id={ClassTabIds[ClassTabItems.ATTENDANCE]}
          aria-controls={ClassTabPanelIds[ClassTabItems.ATTENDANCE]}
          component={Link}
          to={routes.classAttendance.url(params)}
          value={ClassTabItems.ATTENDANCE}
          label={<Typography component="span">{t('attendance', { ns: i18nNS.GLOSSARY })}</Typography>}
        />
      </Tabs>
    </AppBar>
  );
};

export default ClassHeader;
